import React from 'react'
import globalHook, { Store } from 'use-global-hook'

const PERSIST_KEY = 't4'

interface BookedItems {
  [ID: string]: { ID: number, quantity: number }
}
export interface GlobalState {
  [ID: string]: {
    bookedItems?: BookedItems
  }
}

export interface GlobalActions {
  setExtras: (payload: BookedItems) => void
}

const initialState: GlobalState = JSON.parse(sessionStorage.getItem(PERSIST_KEY)) || {}

const setBookedItems = (
  { state, setState }: Store<GlobalState, GlobalActions>,
  { ID, bookedItems }: {
    ID: number
    bookedItems: BookedItems
  }
): void => {
  const nextState = {
    [ID]: {
      ...state[ID],
      bookedItems: { ...state[ID]?.bookedItems, ...bookedItems }
    }
  }

  setState(nextState)
  sessionStorage.setItem(PERSIST_KEY, JSON.stringify(nextState))
}

export default globalHook<GlobalState, GlobalActions>(React, initialState, { setBookedItems })
